import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from '../../../Shared/Icon/Icon'

import ProductAnalyticsTable from './ProductAnalyticsTable'

function ProductAnalyticsKeywordSearchTable({
  keywords,
  searchTerm,
  activeSearchGroup,
  modalIsOpen,
  dataFetch,
  openModal,
  closeModal,
  wordCountButtonClassName,
  handleWordCountChange,
  tiersData,
}) {
  return (
    <div>
      <ProductAnalyticsTable
        keywords={keywords}
        searchTerm={searchTerm}
        fetch={dataFetch}
        scope="search"
        activeSearchGroup={activeSearchGroup}
        tiersData={tiersData}
      />
      {keywords.data.length > 10
        && <button className="btn btn-transparent btn-block btn-view-all" onClick={openModal}>view all</button>
      }

      <Modal
        isOpen={modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={closeModal}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: 'overlay-modal--container',
          afterOpen: 'overlay-modal--container_after-open',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <button className="btn btn-transparent overlay-modal--close" onClick={closeModal}>
          <Icon type={['far', 'times']} color="grey" />
        </button>
        <div className="overlay-modal">
          <header>
            <h2 className="content-heading__h2">
              <div className="keyword-search-title">
                Keyword Search
              </div>
              <div className="content-heading__buttons">
                <div className="btn-group">
                  <button
                    className={wordCountButtonClassName(2)}
                    onClick={() => handleWordCountChange(2)}
                  >2 words
                  </button>
                  <button
                    className={wordCountButtonClassName(3)}
                    onClick={() => handleWordCountChange(3)}
                  >3 words
                  </button>
                </div>
              </div>
            </h2>
          </header>
          <div className="overlay-modal--content">
            <ProductAnalyticsTable
              type="is-expanded"
              head="is-modal"
              keywords={keywords}
              searchTerm={searchTerm}
              fetch={dataFetch}
              scope="search"
              activeSearchGroup={activeSearchGroup}
              modalIsOpen={modalIsOpen}
              tiersData={tiersData}
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

ProductAnalyticsKeywordSearchTable.propTypes = {
  keywords: PropTypes.object.isRequired,
  searchTerm: PropTypes.string.isRequired,
  activeSearchGroup: PropTypes.number.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  dataFetch: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  wordCountButtonClassName: PropTypes.func.isRequired,
  handleWordCountChange: PropTypes.func.isRequired,
  tiersData: PropTypes.object.isRequired,
}

export default ProductAnalyticsKeywordSearchTable
